import { useState } from 'react';
import { getEtatKwixeo, essaiKwixeo, creerKwixeoClub, synchroniserKwixeoClub } from '../api';

const carte = { border: '1px solid var(--border)', borderRadius: 10, padding: '12px 14px', marginBottom: 16, fontSize: 13 };
const petit = { fontSize: 12, color: 'var(--muted)' };

/** Panneau de la console : état de l'intégration Kwixéo, et essai dans le bac à sable. */
export function PanneauKwixeo() {
  const [e, setE] = useState(null);
  const [essai, setEssai] = useState(null);
  const [occupe, setOccupe] = useState(false);
  const tester = async () => { setOccupe(true); try { setE(await getEtatKwixeo()); } catch (x) { setE({ error: x.message }); } setOccupe(false); };
  const lancerEssai = async () => {
    setOccupe(true); setEssai(null);
    try { setEssai(await essaiKwixeo('annuel')); } catch (x) { setEssai({ error: x.message, detail: x.detail }); }
    setOccupe(false);
  };
  return (
    <div style={carte}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
        <b>💶 Facturation Kwixéo</b>
        <span style={{ display: 'flex', gap: 6 }}>
          <button type="button" className="btn" disabled={occupe} onClick={tester}>Tester la connexion</button>
          <button type="button" className="btn" disabled={occupe} onClick={lancerEssai}>Essai dans le bac à sable</button>
        </span>
      </div>
      {e && (
        <div style={{ marginTop: 10 }}>
          {!e.configure && !e.error && <div>Non configuré : KWIXEO_API_KEY absente du serveur.</div>}
          {e.configure && (
            <>
              <div>Mode : <b style={{ color: e.mode === 'reel' ? '#22c55e' : '#eab308' }}>{e.mode === 'reel' ? 'RÉEL' : 'TEST (bac à sable)'}</b>
                {' · '}connexion {e.connexion ? '✓' : <b style={{ color: 'var(--danger)' }}>✗ {e.error}</b>}
                {' · '}notifications {e.webhook ? '✓ secret configuré' : <b style={{ color: '#eab308' }}>secret absent</b>}</div>
              {e.reglages && <div style={{ ...petit, marginTop: 6, lineHeight: 1.6 }}>
                {Object.entries(e.reglages).map(([k, v]) => <div key={k}>{k} : {v || <b style={{ color: 'var(--danger)' }}>introuvable</b>}</div>)}</div>}
              {e.manquants?.length > 0 && <div style={{ color: 'var(--danger)', marginTop: 6 }}>À créer dans Kwixéo : {e.manquants.join(', ')}</div>}
              {e.evenements?.length > 0 && <div style={{ ...petit, marginTop: 8 }}><b>Dernières notifications</b>
                {e.evenements.map((x, i) => <div key={i}>{x.recu_le} · {x.evenement} n° {x.objet_id} → {x.resultat}</div>)}</div>}
            </>)}
        </div>)}
      {essai && (
        <div style={{ marginTop: 10, ...petit }}>
          {essai.ok
            ? <span style={{ color: '#22c55e' }}>✓ Essai réussi dans le bac à sable : client n° {essai.clientId}, contrat n° {essai.contratId}{essai.statut ? ` (${essai.statut})` : ''}.
                {essai.empruntes?.length > 0 && <span style={{ color: 'var(--muted)' }}> Format des requêtes validé, avec les réglages de démonstration du bac à sable : {essai.empruntes.join(', ')}.</span>}</span>
            : <span style={{ color: 'var(--danger)' }}>✗ {essai.error}{essai.detail ? ` — ${JSON.stringify(essai.detail).slice(0, 400)}` : ''}</span>}
        </div>)}
    </div>
  );
}

/** Ligne Kwixéo dans la fiche d'un club. */
export function LigneKwixeoClub({ club, notifier, recharger }) {
  const [occupe, setOccupe] = useState(false);
  const agir = async (f, ok) => {
    setOccupe(true);
    try { const r = await f(club.id); notifier?.(ok(r), 'success'); recharger?.(); }
    catch (x) { notifier?.(`${x.message}${x.detail ? ' — ' + JSON.stringify(x.detail).slice(0, 200) : ''}`, 'error'); }
    setOccupe(false);
  };
  return (
    <div style={{ fontSize: 12.5, margin: '4px 0 10px' }}>
      <div>
        <b>Kwixéo</b>{club.kwixeo_mode === 'test' && <span style={{ color: '#eab308' }}> (bac à sable)</span>} :{' '}
        {club.kwixeo_contrat_id
          ? <>contrat n° {club.kwixeo_contrat_id} · {club.kwixeo_formule} · {club.kwixeo_etat || '—'}</>
          : <span style={{ color: 'var(--muted)' }}>{club.kwixeo_etat === 'erreur' ? '' : 'aucun contrat'}</span>}
        {club.kwixeo_erreur && club.kwixeo_etat === 'erreur' && <span style={{ color: 'var(--danger)' }}> erreur : {club.kwixeo_erreur}</span>}
      </div>
      <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
        {(!club.kwixeo_contrat_id || club.kwixeo_etat === 'erreur') && (
          <button type="button" className="btn" disabled={occupe}
                  onClick={() => agir(creerKwixeoClub, r => `Contrat Kwixéo n° ${r.contratId} créé (${r.mode === 'test' ? 'bac à sable' : 'réel'})`)}>
            Créer dans Kwixéo</button>)}
        {(club.kwixeo_contrat_id || club.kwixeo_client_id) && (
          <button type="button" className="btn" disabled={occupe}
                  onClick={() => agir(synchroniserKwixeoClub, r => ({
                    aucun: 'Aucun contrat', introuvable: 'Contrat introuvable dans Kwixéo : la fiche l\'a oublié',
                  }[r.contrat.statut] || `Contrat ${r.contrat.libelle || r.contrat.statut}`) + ` · ${r.factures.length} facture(s) vérifiée(s)`)}>
            Resynchroniser avec Kwixéo</button>)}
      </div>
    </div>
  );
}
